import { STATUS } from "@/mock/data";
import { yaPaso } from "@/lib/zona";
import { eur } from "@/lib/gastos";

// Agenda: une, sin copiar, lo que ya carga la app (asuntos, seguimientos, gestiones y sus ocurrencias).
const sumar = (iso, n) => { const d = new Date(iso + "T00:00:00"); d.setDate(d.getDate() + n); return d.toLocaleDateString("sv-SE"); };

export const GRUPOS = [
  ["atrasado", "Atrasado"], ["hoy", "Hoy"], ["manana", "Mañana"], ["semana", "Esta semana"], ["adelante", "Más adelante"],
];
export const FILTROS = [["todo", "Todo"], ["recordatorio", "Recordatorios"], ["pago", "Pagos"], ["plan", "Planes"]];

const pendiente = (m) => {
  if (!m.due_date || m.status === STATUS.DONE) return false;
  if (m.recordatorio_puntual) return true;
  if (m.status === STATUS.ATTENTION || m.status === STATUS.UPCOMING) return true;
  return (m.tipo === "evento" || m.avisos_activos || m.category === "Ocio") && m.status !== STATUS.PAST;
};

export const itemsAgenda = ({ matters, reminders, gestiones, ocs, today }) => {
  const asuntos = matters.filter(pendiente);
  const vistos = new Set(asuntos.map((m) => m.id));
  const ocAbiertas = new Set(ocs.map((o) => `${o.gestion_id}|${o.fecha}`));
  const gMap = Object.fromEntries(gestiones.map((g) => [g.id, g]));
  const items = [
    ...asuntos.map((m) => ({
      id: m.id, date: m.due_date, time: m.due_time || "", title: m.title, sub: m.due_label, status: m.status,
      atrasado: m.due_date < today || (m.recordatorio_puntual && m.status === STATUS.PAST),
      kind: m.category === "Ocio" ? "plan" : m.recordatorio_puntual ? "recordatorio" : "matter",
      filtro: m.category === "Ocio" ? "plan" : m.amount != null && !m.recordatorio_puntual ? "pago" : "recordatorio",
      route: m.category === "Ocio" && m.plan_id ? `/ocio?plan=${m.plan_id}` : `/asunto/${m.id}`,
    })),
    ...(reminders || [])
      .filter((r) => r.tipo === "seguimiento" && r.status === "Programado" && r.reminder_date && !vistos.has(r.asunto_id))
      .map((r) => ({
        id: r.id, date: r.reminder_date, time: r.reminder_time || "", title: r.text || "Seguimiento", sub: r.date_label,
        status: STATUS.UPCOMING, atrasado: yaPaso(r.reminder_date, r.reminder_time), kind: "seguimiento", filtro: "recordatorio", seguimiento: true,
        route: r.asunto_id ? `/asunto/${r.asunto_id}` : "/correos",
      })),
    // Pagos o recordatorios periódicos ya generados y sin hacer (hoy o atrasados).
    ...ocs.filter((o) => !gMap[o.gestion_id]?.en_papelera).map((o) => ({
      id: o.id, date: o.fecha, time: "", title: o.titulo, status: STATUS.UPCOMING, atrasado: o.fecha < today,
      sub: o.importe != null ? `Pago pendiente · ${eur(o.importe)}` : "Recordatorio periódico pendiente",
      kind: "periodico", filtro: o.importe != null ? "pago" : "recordatorio", route: `/gestiones/${o.gestion_id}`,
    })),
    // Próxima fecha de cada periódico activo, si no está ya como pendiente.
    ...gestiones.filter((g) => g.estado === "activa" && !g.en_papelera && g.proxima && g.proxima >= today && !ocAbiertas.has(`${g.id}|${g.proxima}`)).map((g) => ({
      id: g.id, date: g.proxima, time: "", title: g.titulo, status: STATUS.UPCOMING, atrasado: false,
      sub: g.importe != null ? `Pago periódico · ${eur(g.importe)}` : "Recordatorio periódico",
      kind: "periodico", filtro: g.importe != null ? "pago" : "recordatorio", route: `/gestiones/${g.id}`,
    })),
  ];
  return items.sort((a, b) => a.date.localeCompare(b.date) || (a.time || "99:99").localeCompare(b.time || "99:99"));
};

export const grupoDe = (i, today) => {
  if (i.atrasado) return "atrasado";
  if (i.date === today) return "hoy";
  if (i.date === sumar(today, 1)) return "manana";
  const dow = (new Date(today + "T00:00:00").getDay() + 6) % 7; // lunes = 0
  return i.date <= sumar(today, 6 - dow) ? "semana" : "adelante";
};
